<template>
	<div class="view-content">
		<div class="view-content-info">
			<div class="user-login" v-if="show">
				<div class="user-login-title"><span>填写订单信息</span></div>
				
				<div class="order">
					<div class="order-title">填写订单信息</div>
					<div class="address flex-between flex-center">
						<div class="address-info" v-if="address != null">
							<div><span>收货人：</span>{{address.receiveName}}</div>
							<div><span>联系方式：</span>{{address.phone}}</div>
							<div><span>收货地址：</span>{{address.province}}{{address.city}}{{address.county}}{{address.detailAddress}}</div>
						</div>
						<div class="address-info" v-else>
							<div>请选择地址</div>
						</div>
						
						<div class="address-edit flex-center flex-midden" v-if="address != null" @click="editAddress(address.id)">
							<img src="@/assets/images/edit.png"/>
							<div>修改地址</div>
						</div>
						
						<div class="address-action">
							<div @click="showChangeAddress">切换地址</div>
							<div @click="addaddress">添加地址</div>
						</div>
					</div>
					
					<div class="order-title">商品信息</div>
					
					
					<div class="ordergoods-table" v-if="list.length > 0">
						<div class="ordergoods-table-title flex-center flex-between">
							<div class="ordergoods-table-title-title">商品信息</div>
							<div class="ordergoods-table-title-price">单价</div>
							<div class="ordergoods-table-title-price">数量</div>
							<div class="ordergoods-table-title-price">小计</div>
							<div class="ordergoods-table-title-price">实付</div>
						</div>
						<div class="ordergoods-table-body">
							<div v-for="item in list" :key="item.id" class="ordergoods-table-item flex-between flex-center">
								
								<div class="ordergoods-table-item-goods flex-start flex-center" @click="toInfo(item.goodsId)">
									<img class="ordergoods-table-item-goods-image" :src="item.image" mode="aspectFill"></img>
									<div class="ordergoods-table-item-goods-text">
										<div>{{item.goodsName}}</div>
										<div>{{item.name}}</div>
									</div>
									<div class="ordergoods-table-item-price">￥{{item.presentPrice}}</div>
									<div class="ordergoods-table-item-price">{{item.goodsNum}}</div> 
									<div class="ordergoods-table-item-value">￥{{item.totalPrice}}</div> 
									<div class="ordergoods-table-item-value">￥{{item.totalPrice}}</div> 
								</div>
							</div>
						</div>
					</div>
					
					
					<div class="order-title">使用优惠券</div>
					
					<div class="selectCoupon" v-if="info.couponAvailableNum > 0" @click="selectCoupon">选择优惠券</div>
					<div class="selectCoupon" v-else>暂无可用优惠券</div>
					
					<div class="coupon-num">共 <span>{{info.couponTotalNum}}</span> 张优惠券，其中 <span>{{info.couponAvailableNum}}</span> 张可用  <router-link class="a" to="coupon" target="_blank">兑换优惠券</router-link></div>
					
					
					<div class="score flex-start flex-center">
						<!-- <img src="@/assets/images/no-radio.png"/> -->
						<div class="score-title">使用积分</div>
						
						<div class="score-content">
							<el-input-number style="width: 100%;text-align: left;" v-model="integral" :max="submitPirce" @change="getList" :controls="false" label="请输入抵扣积分"></el-input-number>
							
							<div v-if="totalintegral <= submitPirce" class="score-content-text flex-between flex-center">
								<div>当前账户可用积分{{totalintegral}}分</div>
								<div @click="integral = totalintegral,getList()">全部使用</div>
							</div>
							<div v-else class="score-content-text flex-between flex-center">
								<div>当前账户可用积分{{totalintegral}}分</div>
								<div @click="integral = submitPirce,getList()">全部使用</div>
							</div>
						</div>
					</div>
					
					
					
					<div class="order-title">订单备注</div>
					<div style="padding: 0 0 10px 0;">
						<el-input
							type="textarea"
							v-model="remark"
							:rows="3"
							maxlength="200"
							show-word-limit
							placeholder="选填，请输入订单备注（如送货时间要求、特殊说明等）"
						></el-input>
					</div>

					<div class="order-title">金额明细</div>
					
					<div class="order-result flex-end">
						<div class="order-result-item">
							<div class="order-result-item-text">
								商品件数：<span>{{totalGoodsNum}}件</span>
							</div>
							<div class="order-result-item-text">
								商品总价：<span>￥{{info.goodsPrice}}</span>
							</div>
							<div class="order-result-item-text">
								优惠券抵扣：<span>￥{{info.couponPrice}}</span>
							</div>
							<div class="order-result-item-text">
								积分抵扣：<span>￥{{info.integralPrice}}</span>
							</div>
							<div class="order-result-item-text">
								运费：<span>￥{{info.freightPrice}}</span>
							</div>
							<div class="order-result-item-text">
								应付总额：<span>￥{{info.meetPrice}}</span>
							</div>
							
							<el-button class="order-result-item-button" :loading="isSubmit" @click="submitOrder">提交订单</el-button>
						</div>
					</div>
				</div>
			</div>
		</div>
		
		
		<addressForm ref="addressRef" @success="addressChange"></addressForm>
		<addressSelect ref="addressSelectRef" @success="addressSubmit"></addressSelect>
		<couponSelect ref="couponSelectRef" @success="couponSubmit"></couponSelect>
		
	</div>
</template>

<script>
	import {computePrice,createOrder} from "@/api/user"
	import {getAddressList,getAddressById,getUserInfo} from "@/api/user"
	import addressForm from '@/components/addressForm.vue'
	import addressSelect from '@/components/addressSelect.vue'
	import couponSelect from '@/components/couponSelect.vue'
	export default {
		components:{
			addressForm,
			addressSelect,
			couponSelect
		},
		data(){
			return {
				goods:{},
				isCart:1,
				couponId:"",//选择的优惠券
				list:[],//商品列表
				remark:"",//备注
				info:{},//基础信息
				address:null,
				addressList:[],
				show:false,
				isSubmit:false,
				couponList:[],
				integral:"",
				totalintegral:0,
				submitPirce:0
			}
		},
		computed:{
			totalGoodsNum(){
				return this.list.reduce((total, item) => total + Number(item.goodsNum || 0), 0);
			}
		},
		mounted() {
			this.isCart = this.$route.query.is_cart || 1;
			if(this.isCart == 1){
				this.goods = {
					goodsSpecId:this.$route.query.id || 0,
					num:this.$route.query.num || 1
				};
			}
			getUserInfo().then(res=>{
				if(res.code == 1000){
					this.totalintegral = res.data.integral;
				}
			})
			this.getList();
		},
		methods:{
			getList(){
				computePrice({
					province:this.address?this.address.province:'',
					goods:this.goods,
					isCart:this.isCart,
					couponId:this.couponId,
					integral:this.integral
				}).then(res=>{
					if(res.code == 1000){
						this.list = res.data.goodsList;
						this.info = res.data;
						//如果没有选择地址，则替换地址
						if(this.address == null){
							this.address = res.data.address;
						}
						if(this.integral == 0){
							this.submitPirce = this.info.meetPrice;
						}
						this.show = true;
					}else{
						return this.$message.error(res.message);
					}
				})
			},
			addressChange(){
				if(this.address != null){
					getAddressById({id:this.address.id}).then(res=>{
						if(res.code == 1000){
							this.address = res.data;
							this.couponId = "";
							this.integral = "";
							this.getList();
						}else{
							return this.$message.error(res.message);
						}
					})
				}else{
					this.getList();
				}
			},
			addressSubmit(e){
				this.address = e;
				this.couponId = "";
				this.integral = "";
				this.getList();
			},
			toInfo(id){
				window.open("/goodsinfo?id="+id);
			},
			addaddress(){
				this.$refs.addressRef.init(0);
			},
			//编辑地址
			editAddress(id){
				this.$refs.addressRef.init(id);
			},
			//切换地址
			showChangeAddress(){
				this.$refs.addressSelectRef.init(this.address);
			},
			//选择优惠券
			selectCoupon(){
				this.$refs.couponSelectRef.init(this.couponId,this.info.meetPrice);
			},
			couponSubmit(id){
				this.integral = "";
				this.couponId = id;
				this.getList();
			},
			submitOrder(){
				if(this.address == null){
					return this.$message.error("请选择收货地址");
				}
				this.isSubmit = true;
				createOrder({
					addressId:this.address.id,
					goods:this.goods,
					isCart:this.isCart,
					couponId:this.couponId,
					remark:this.remark ? this.remark.trim() : "",
					integral:this.integral
				}).then(res=>{
					if(res.code == 1000){
						this.$router.replace("/pay?id="+(res.data*23+20));
					}else{
						this.isSubmit = false;
						return this.$message.error(res.message);
					}
				})
			}
		}
	}
</script>
<style scoped lang="scss">
	.order-result{
		border-top: 1px solid rgba(0, 0, 0, 0.1);
		padding-top: 10px;
		.order-result-item{
			.order-result-item-text{
				font-size: 16px;
				font-weight: 500;
				line-height: 40px;
				color: #070B13;
				width: 280px;
				text-align: right;
				span{
					color: #E91A12;
					width: 170px;
					display: inline-block;
				}
			}
			
			.order-result-item-button{
				width: 240px;
				height: 56px;
				background: #E91A12;
				font-size: 20px;
				font-weight: 500;
				letter-spacing: 0em;
				text-align: center;
				color: #FFFFFF;
				margin: 30px 0px 0px 40px;
				border: 0px;
			}
		}
	}
	.selectCoupon{
		width: 229px;
		height: 44px;
		border: 1px solid rgba(233, 26, 18, 0.3);
		color: #E91A12;
		text-align: center;
		line-height: 44px;
		cursor: pointer;
	}
	.coupon-num{
		margin-top: 16px;
		font-size: 14px;
		color: #9C9DA1;
		span{
			color: #E91A12;
		}
		.a{
			color: #165DFF;
			cursor: pointer;
		}
	}
	.ordergoods-table-body{
		padding: 0px;
		.ordergoods-table-item{
			padding-left: 40px;
			padding-right: 40px;
			box-sizing: border-box;
			font-size: 14px;
		}
	}
	.order{
		width: 1320px;
		background: #FFFFFF;
		padding: 0px 40px 60px;
		box-sizing: border-box;
		.order-title{
			font-size: 16px;
			font-weight: 500;
			color: #070B13;
			line-height: 72px;
		}
		.address{
			border: 1px solid rgba(0, 0, 0, 0.1);
			box-sizing: border-box;
			padding: 20px 60px 20px 30px;
			.address-edit{
				flex: 0 0 100px;
				margin-right: 60px;
				img{
					width: 20px;
					height: 20px;
					flex: 0 0 20px;
					margin-right: 12px;
				}
				div{
					font-size: 16px;
					line-height: 20px;
					color: #070B13;
				}
			}
			.address-action{
				border-left: 1px solid rgba(0, 0, 0, 0.1);
				padding-left: 60px;
				div{
					width: 152px;
					height: 36px;
					border: 1px solid rgba(7, 11, 19, 0.3);
					font-size: 14px;
					color: #070B13;
					line-height: 36px;
					text-align: center;
					margin: 8px 0px;
					cursor: pointer;
					&:last-of-type{
						color: rgba(233, 26, 18, 1);
					}
				}
			}
			.address-info{
				width: 100%;
				div{
					font-size: 16px;
					line-height: 22px;
					color: #070B13;
					padding: 8px 0px;
					span{
						width: 90px;
						font-size: 16px;
						color: rgba(7, 11, 19, 0.6);
						display: inline-block;
					}
				}
			}
		}
	}
	@import url("../assets/order.scss");
	::v-deep .el-input-number .el-input__inner{
		text-align: left !important;
	}
</style>